import { requestService as api } from "../Request.service";

const API_URL = {
  API_MANAGE: `/ERP/common/production-system.php`,
};

/* ทะเบียนระบบการผลิต — ใช้ในหน้า Finished Goods */
const ProductionSystemService = () => {
  const list = () => api.get(`${API_URL.API_MANAGE}`, { ignoreLoading: true });
  const create = (name) => api.post(`${API_URL.API_MANAGE}`, { name });
  const update = (id, name) => api.put(`${API_URL.API_MANAGE}`, { id, name });
  const deleted = (id) => api.delete(`${API_URL.API_MANAGE}?id=${id}`);

  return { list, create, update, deleted };
};

export default ProductionSystemService;
